<template>
    <rkm-modal
        :buttons="['cancel']"
        :title="`Paciente: ${paciente.nome}`"
        ref="Modal"
        extraLarge
    >
        <rkm-table
            :fields="fields"
            :items="items"
            no-footer-sorting
            sort-by=""
        >
        </rkm-table>

    </rkm-modal>
</template>

<script>
// Vuex
import { mapActions } from "vuex";

// Mixins
import { repository, error, data, object, stringCase, file } from "@/mixins";

export default {
    computed: {
        fields() {
            return [
                { key: 'exame', label: 'Exame' },
                { key: 'usuarioCadastro', label: 'Usuário que Cadastrou' },
                { key: 'usuarioAlteracao', label: 'Usuário que Alterou' },
                { key: 'dataHoraModificacao', label: 'Data/hora da Modificação' },
                { key: 'acao', label: 'Ação' },
                { key: 'status', label: 'Status' },
                { key: 'dataHorarioAgendamento', label: 'Data/horário agendamento' },
            ];
        },
    },
    created() {
        this.repositories = {
            agendar:this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        };
    },
    data: () => ({
        items: [],

    }),
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load(idAgendamento) {
            this.setLoading();
            this.repositories.agendar
                .getHistoricoExame(idAgendamento)
                .then(({data}) => {
                    this.items = data;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        open(idAgendamento) {
            this.items = [];
            this.$refs.Modal.show()
            this.load(idAgendamento);
        },
        save() {
            this.$refs.Modal.hide();
        }
    },
    props: {
        data: { type: Object, required: true },
        paciente: { type: Object, required: true},
    },

    mixins: [repository, error, data, object, stringCase, file],
}
</script>